export function ScoreGauge({ value, label, invert = false, size = 120 }) {
  const v = Math.max(0, Math.min(100, value || 0));
  const r = size / 2 - 10;
  const circ = Math.PI * r; // semicircle
  const offset = circ * (1 - v / 100);
  const good = invert ? v < 40 : v > 65;
  const mid = invert ? v < 65 : v > 40;
  const color = good ? "#059669" : mid ? "#D97706" : "#DC2626";
  return (
    <div className="flex flex-col items-center" data-testid={`gauge-${label}`}>
      <svg width={size} height={size / 2 + 14} viewBox={`0 0 ${size} ${size / 2 + 14}`}>
        <path d={`M 10 ${size / 2} A ${r} ${r} 0 0 1 ${size - 10} ${size / 2}`}
          fill="none" stroke="#E2E8F0" strokeWidth="10" strokeLinecap="round" />
        <path d={`M 10 ${size / 2} A ${r} ${r} 0 0 1 ${size - 10} ${size / 2}`}
          fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.16,1,0.3,1)" }} />
        <text x={size / 2} y={size / 2 - 4} textAnchor="middle"
          className="font-mono" fontSize="22" fontWeight="600" fill="#0F172A">{v}</text>
      </svg>
      <div className="overline text-muted-foreground -mt-1">{label}</div>
    </div>
  );
}

export function Bar({ value, color = "#002FA7" }) {
  const v = Math.max(0, Math.min(100, value));
  return (
    <div className="h-1.5 w-full bg-secondary overflow-hidden">
      <div style={{ width: `${v}%`, background: color, transition: "width 0.8s ease" }} className="h-full" />
    </div>
  );
}
